import React, { ImgHTMLAttributes } from "react";

import LogoStetoRound from "@/assets/img/logo-steto-round.png";
import OmnipodPump from "@/assets/img/omnipod.png";
import StetoInfo from "@/assets/img/steto-info-2.png";
import TandemPump from "@/assets/img/tandem.png";

export type ImageProps = Omit<
  React.DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  "src" | "alt"
> & { alt: string };
export const Image: (src: string) => React.FC<ImageProps> = src => {
  const _Image: React.FC<ImageProps> = ({ alt, ...props }) => <img src={src} alt={alt} {...props} />;

  return _Image;
};

export const Images = {
  stetoInfo: Image(StetoInfo),
  logoStetoRound: Image(LogoStetoRound),
  tandemPump: Image(TandemPump),
  omnipodPump: Image(OmnipodPump),
};
